import objectPath from 'object-path'

const getRuleFetchComponentTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

export const onRuleFetchComponent = (
  designContext = {},
  action = {},
  target = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let targetKey = getRuleFetchComponentTarget(action, target)
  if (!targetKey) return undefined

  objectPath.set(isUiChanged, targetKey, {
    isRender: true,
    isFetchComponent: true,
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: targetKey,
    isFetchComponent: true,
  }
}
